const map = {
	"./Eyes/eyes-2.webp": 7337,
	"./Eyes/eyes.webp": 1614,
	"./Eyes/golden-eye-1.webp": 379,
	"./Eyes/golden-eye-2.webp": 6282,
	"./Eyes/golden-eye-3.webp": 309,
	"./Eyes/golden-eye-4.webp": 100,
	"./Eyes/golden-eye-5.webp": 4807,
	"./Eyes/golden-eye-6.webp": 9334,
	"./Eyes/red-eye.webp": 3447,
	"./Masks/golden-mask.webp": 5085,
	"./Masks/mononoke-mask.webp": 6030,
	"./Masks/new-mask.webp": 9674,
	"./Masks/tengu-mask.webp": 4765,
	"./Nature/kingfisher.webp": 5489,
	"./Nature/magpies.webp": 6173,
	"./Nature/poinsettia.webp": 4431,
	"./Nature/wagtails.webp": 2779,
	"./Nature/yellow-tree.webp": 878,
	"./Other/bad-ideas.webp": 4384,
	"./Other/blue-hair.webp": 2485,
	"./Other/collage-wall.webp": 3970,
	"./Other/purple-hair.webp": 3599,
	"./Other/skateboard.webp": 3872,
	"./Other/tessa-both.webp": 1018,
	"./Other/tessa-red.webp": 40,
	"./Other/tessa-yellow.webp": 433
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2557;